<span class="description">
  {{ nameKey | translate }}
</span>
<automata-crm-created-modified [(value)]="action"></automata-crm-created-modified>

<automata-automation-replacement-chips
  [label]="'CRM_FIELDS_DIALOG.CUSTOM_OBJECT_TYPE'"
  [dataService]="crmCustomObjectTypeSelectorService"
  [formControl]="customObjectTypeFormControl"
  [isRequired]="true"
  [multiple]="false"
  [supportDataPassing]="false"
  (finishedInitialLoading)="finishedLoading()"
></automata-automation-replacement-chips>

@if (rerenderReplacementChipsTrigger() && hasObjectTypeSelected() && action !== comparison.Created) {
  <automata-automation-replacement-chips
    [label]="labelDisplay"
    [dataService]="crmFieldsSelectorService"
    [formControl]="fieldFormControl"
    [isRequired]="true"
    [multiple]="true"
    [supportDataPassing]="false"
    [extraData]="{
      supportedFieldTypes: supportedFieldTypes,
      crmObjectType: 'CustomObject',
      crmObjectSubtype: customObjectTypeFormControl.value,
      filterToOnlyStandardFields: onlyStandardFields,
    }"
  ></automata-automation-replacement-chips>
  <div class="description">
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CREATED_MODIFIED.DESCRIPTION' | translate }}
  </div>
}
